module.exports = __webpack_public_path__ + "static/img/jeju-do.b3c92cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mapFragment/jeju-do.png
// module id = 2M5V
// module chunks = 3